<template>
  <div class="form-user mx-auto my-10">
    <ValidationObserver
      ref="observer"
      v-slot="{ invalid }"
    >
      <form @submit.prevent="onSubmit">
        <ValidationProvider name="name" rules="required" v-slot="{ errors }">
          <v-text-field
            label="Nome"
            type="text"
            v-model="user.name"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>
        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
          <v-text-field
            label="E-mail"
            type="email"
            v-model="user.email"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>
        <ValidationProvider v-if="isNew" name="password" rules="required" v-slot="{ errors }">
          <v-text-field
            label="Senha"
            type="password"
            v-model="user.password"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>
        <ValidationProvider name="roles" rules="required" v-slot="{ errors }">
          <v-select
            v-model="user.roles"
            :error-messages="errors"
            :items="roles"
            item-text="text"
            item-value="value"
            label="Perfis"
            multiple
            filled
            required
          ></v-select>
        </ValidationProvider>
        <ValidationProvider name="auth" rules="required" v-slot="{ errors }">
          <v-select
            v-model="user.auth"
            :error-messages="errors"
            :items="authTypes"
            item-text="text"
            item-value="value"
            label="Autenticação"
            filled
            required
          ></v-select>
        </ValidationProvider>

        <v-divider class="my-5"></v-divider>

        <v-btn
          block
          rounded
          large
          class="my-2"
          type="submit"
          color="primary"
          :disabled="invalid"
        >
          {{ isNew ? 'Criar' : 'Editar' }}
        </v-btn>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import User from "@/models/user";

export default {
  name: 'FormUser',
  emits: ['submitUser'],
  props: {
    isNew: Boolean,
    user: User,
  },
  data: () => ({
    roles: [
      {
        text: 'Estudante',
        value: 'student',
      },
      {
        text: 'Professor',
        value: 'teacher',
      },
      {
        text: 'Administrador',
        value: 'admin',
      },
    ],
    authTypes: [
      {
        text: 'LDAP Estudantes',
        value: 'ldap_student',
      },
      {
        text: 'Senha',
        value: 'password',
      },
    ]
  }),
  mounted() {
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate();

      this.$emit('submitUser', this.user);
    }
  },
};
</script>

<style scoped>
.form-user {
  max-width: 50%;
}
</style>
